import { BaseListViewStore, DateTimeCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import { checkForColumnWidth } from 'core/utils';
import { localStorageHandler } from 'core/services';
import ScheduledJobLogStore from './ScheduledJobLogStore';
import { ScheduledJobLogDetails } from '../pages';

class ScheduledJobLogListViewStore extends BaseListViewStore {
	@observable data = [];
	@observable searchText = '';

	constructor(rootStore) {
		super(rootStore, {
			listStore: new ScheduledJobLogStore(rootStore),
			findFunction: 'findScheduledJobLogs',
			tableData: {
				columns: [
					{
						key: 'jobTitle',
						title: 'Job Title',
						sortable: true,
					},
					{
						key: 'startedAt',
						title: 'Started At',
						sortable: true,
						dataCell: DateTimeCellData,
						dateFormat: 'LLL',
						useLocalTime: true,
						dontConvertTime: true,
					},
					{
						key: 'finishedAt',
						title: 'Finished At',
						sortable: true,
						dataCell: DateTimeCellData,
						dateFormat: 'LLL',
						useLocalTime: true,
						dontConvertTime: true,
					},
					{
						key: 'jobIdentifier',
						title: 'Job Identifier',
						sortable: true,
					},
				],
				sortObject: [],
				actions: {
					onOpenScheduledJobLogDetailsModal: async item => this.openScheduledJobLogDetailsModal(item),
				},
			},
			permissions: {
				onOpenScheduledJobLogDetailsModal: () => true,
			},
		});
		makeObservable(this);
		this.initialize();
	}

	@action.bound
	findScheduledJobLogs = async () => {
		await this.listStore.findScheduledJobLogs(this.queryUtility.filter);
		let responseData = this.listStore.response;
		this.queryUtility.handleResponse(responseData);
	};

	@action.bound
	setSearchText = value => {
		this.searchText = value;
	};

	getFilteredData = () => {
		const data = this.listStore.data.slice();
		const term = this.searchText.trim().toLowerCase();
		if (!term) return data;
		return _.filter(data, item =>
			_.some(this.tableData.columns, column => this.getDisplayValue(item, column).toLowerCase().includes(term))
		);
	};

	// Match against what the cell shows, so dates are searched in their displayed format
	getDisplayValue = (item, column) => {
		const value = _.get(item, column.key);
		if (value === null || value === undefined || value === '') return '';
		if (column.dataCell === DateTimeCellData) return moment.utc(value).local().format(column.dateFormat);
		return String(value);
	};

	@action.bound
	openScheduledJobLogDetailsModal = item => {
		try {
			this.openModal({
				data: { job: item },
				component: ScheduledJobLogDetails,
				className: 'modal-job-details',
			});
		} catch (err) {}
	};

	@action.bound
	initialize = async () => {
		this.suspend();
		checkForColumnWidth(localStorageHandler.get('fulfillment-orders-column-width'), this.tableData.columns);
		this.setHeaderModes();
		this.queryUtility.initialize(this.findScheduledJobLogs);
		this.resume();
	};
}

export default ScheduledJobLogListViewStore;
